var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4596_14684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9216 31.2764C46.5457 27.2834 43.3689 25.1371 39.0248 23.7053L40.434 18.2965L36.9933 17.4761L35.6214 22.7425C34.7168 22.5266 33.7879 22.3232 32.8647 22.1215L34.2465 16.8204L30.8079 16L29.3978 21.407C28.6493 21.2439 27.9141 21.0827 27.2008 20.9129L27.2048 20.8959L22.4599 19.7621L21.5446 23.2786C21.5446 23.2786 24.0974 23.8386 24.0436 23.873C25.4369 24.2058 25.6889 25.0884 25.647 25.788L24.0417 31.9498C24.1377 31.9731 24.2621 32.0069 24.3995 32.0597C24.2847 32.0324 24.1625 32.0026 24.0358 31.9736L21.7857 40.6054C21.6154 41.0105 21.1832 41.6184 20.2091 41.3875C20.2436 41.4354 17.7083 40.7904 17.7083 40.7904L16 44.5592L20.4776 45.6273C21.3106 45.8272 22.1269 46.0363 22.9307 46.233L21.5069 51.7038L24.9437 52.5242L26.3537 47.1115C27.2926 47.3554 28.2038 47.5803 29.0957 47.7924L27.6905 53.1796L31.1314 54L32.5551 48.5395C38.4223 49.602 42.834 49.1736 44.6909 44.0954C46.1872 40.0069 44.6164 37.6486 41.5297 36.1108C43.7779 35.6146 45.4713 34.1997 45.9228 31.2768L45.9218 31.2761L45.9216 31.2764ZM38.0603 41.8249C36.9969 45.9134 29.8031 43.7033 27.4707 43.1491L29.3601 35.9012C31.6923 36.4584 39.1716 37.5609 38.0604 41.8249H38.0603ZM39.1244 31.2171C38.1544 34.9361 32.1668 33.0467 30.2245 32.5834L31.9376 26.01C33.8799 26.4733 40.1349 27.338 39.1247 31.2171H39.1244Z",
    fill: "url(#paint0_linear_4596_14684)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9216 31.2764C46.5457 27.2834 43.3689 25.1371 39.0248 23.7053L40.434 18.2965L36.9933 17.4761L35.6214 22.7425C34.7168 22.5266 33.7879 22.3232 32.8647 22.1215L34.2465 16.8204L30.8079 16L29.3978 21.407C28.6493 21.2439 27.9141 21.0827 27.2008 20.9129L27.2048 20.8959L22.4599 19.7621L21.5446 23.2786C21.5446 23.2786 24.0974 23.8386 24.0436 23.873C25.4369 24.2058 25.6889 25.0884 25.647 25.788L24.0417 31.9498C24.1377 31.9731 24.2621 32.0069 24.3995 32.0597C24.2847 32.0324 24.1625 32.0026 24.0358 31.9736L21.7857 40.6054C21.6154 41.0105 21.1832 41.6184 20.2091 41.3875C20.2436 41.4354 17.7083 40.7904 17.7083 40.7904L16 44.5592L20.4776 45.6273C21.3106 45.8272 22.1269 46.0363 22.9307 46.233L21.5069 51.7038L24.9437 52.5242L26.3537 47.1115C27.2926 47.3554 28.2038 47.5803 29.0957 47.7924L27.6905 53.1796L31.1314 54L32.5551 48.5395C38.4223 49.602 42.834 49.1736 44.6909 44.0954C46.1872 40.0069 44.6164 37.6486 41.5297 36.1108C43.7779 35.6146 45.4713 34.1997 45.9228 31.2768L45.9218 31.2761L45.9216 31.2764ZM38.0603 41.8249C36.9969 45.9134 29.8031 43.7033 27.4707 43.1491L29.3601 35.9012C31.6923 36.4584 39.1716 37.5609 38.0604 41.8249H38.0603ZM39.1244 31.2171C38.1544 34.9361 32.1668 33.0467 30.2245 32.5834L31.9376 26.01C33.8799 26.4733 40.1349 27.338 39.1247 31.2171H39.1244Z",
    fill: "url(#paint1_linear_4596_14684)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4596_14684",
    x: 0,
    y: 0,
    width: 62,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_4596_14684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4596_14684",
    x1: 31,
    y1: 16,
    x2: 31,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB23E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4596_14684",
    x1: 31,
    y1: 16,
    x2: 31,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB23E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtc);
export default __webpack_public_path__ + "static/media/ic_btc.4e99a4f9c39c78dc170bfdf91e6f67f4.svg";
export { ForwardRef as ReactComponent };